// import * as mutation from '../mutations';
import axios from 'axios';
import withDecrypt from '../../src/withDecrypt';
// import decorators from '../../src/api/decorators';
// import requestService from '../../src/api/services/requestService';
// import { home } from '../../src/api/queries';
// import { doHomePageAction } from '../../src/actions';
// import { actionConstants } from '../../src/constants';

async function fetchAPI(query, { variables, preview } = {}) {
  return axios({
    method: 'post',
    url: process.env.NEXT_PUBLIC_API_URL,
    data: {
      query,
    },
    // headers: { 'accessToken': args[0] },
  })
    .then(resp => withDecrypt(resp.data))
    .catch(err => {
      console.log(err);
    });
}

export default async function _getWideScreenerMetricsCount(andor, formula) {
  const removeQuotes = (str) => str.replace(/"/g, "");
  const objectToString = (obj) =>
    `{
    andor: ${removeQuotes(obj.andor)},
    metricsCriteria: [
      ${obj.metricsCriteria
      .map(
        (item) =>
          (item.code === `\`industry\`` || item.code === `\`sector\``) ?
            `{
            code: \"${item?.code?.replace(/`/g, '')}\",
            condition: ${removeQuotes(item.condition)},
            value: "\\"${item.value}\\""
          }`:
            `{
            code: "${item.code}",
            condition: ${removeQuotes(item.condition)},
            value: "${item.value}"
          }`
      )
      .join(",\n")}
    ]
  }`;
  const formulaString = `[${formula.map(objectToString).join(",\n")}]`;
  const data = await fetchAPI(`query { getWideScreenerMetricsCountV3(andor: ${andor}, exclude_bad: true, formula: ${formulaString}) }`)
  return data
}


// // import * as mutation from '../mutations';
// import axios from 'axios';
// import withDecrypt from '../../src/withDecrypt';
// // import decorators from '../../src/api/decorators';
// // import requestService from '../../src/api/services/requestService';
// // import { home } from '../../src/api/queries';
// // import { doHomePageAction } from '../../src/actions';
// // import { actionConstants } from '../../src/constants';

// async function fetchAPI(query, { variables, preview } = {}) {
//   return axios({
//     method: 'post',
//     url: process.env.NEXT_PUBLIC_API_URL,
//     data: {
//       query,
//     },
//     // headers: { 'accessToken': args[0] },
//   })
//     .then(resp => withDecrypt(resp.data))
//     .catch(err => {
//       console.log(err);
//     });
// }

// export default async function _getWideScreenerMetricsCount(mktCapCat, conditions, first, offset) {
//   const data = await fetchAPI(
//     `
//     query {
//       getWideScreenerMetricsCount(metricsCriteria:[${conditions && conditions?.map(d => `{ code:"${d.code}", condition: ${d.condition}, value: ${d.value}, tovalue: ${d.tovalue || null}}`)}], mktCapCat: ${mktCapCat})
//     }
//     `
//   )
//   return data
// }
